import React from 'react';
import { CoreQaToolboxLoader } from './core-qa-toolbox-loader/CoreQaToolboxLoader';
type DevToolingMountProps = {
  currentMapHashId?: string;
  routeMapHashId?: string;
};
export function DevToolingMount({
  currentMapHashId,
  routeMapHashId
}: DevToolingMountProps = {}): React.JSX.Element {
  return <CoreQaToolboxLoader currentMapHashId={currentMapHashId} routeMapHashId={routeMapHashId} data-sentry-element="CoreQaToolboxLoader" data-sentry-component="DevToolingMount" data-sentry-source-file="dev-tooling.tsx" />;
}